import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useDefaultComponentTools } from '../../../../../../hooks/useDefaultComponentTools'


const TableHead = ({headCells, isScrollBar}) => {
	const { theme, t } = useDefaultComponentTools()
	return (
		<Box
			sx={{
				borderBottom: theme.palette.border,
				display: 'flex',
				flexWrap: 'wrap',
				justifyContent: 'space-between',
				marginRight: isScrollBar && '12px',
				p: '12px'
			}}
		>
			{headCells.length < 1 ? null : headCells.map((headCell, index) => {

				return (
					<Box
						sx={{
							m: '0 4px',
							width: `calc(${headCell.width} - 8px)`
						}}
						key={index}
					>
						<Typography
							color={theme.palette.text.primary}
							sx={{
								textAlign: index && 'center'
							}}
						>
							{t(headCell.label)}
						</Typography>
					</Box>
				)
			})}
		</Box>

	)
}

TableHead.propTypes = {
	headCells: PropTypes.array,
	isScrollBar: PropTypes.bool
}

export default TableHead
